<template>
  <div class="h-5 space-x-4" :class="!leftArrowDisabled || !rightArrowDisabled ? 'inline-flex' : 'hidden'">
    <ArrowButton
      direction="left"
      :arrow-disabled="leftArrowDisabled"
      :inverted="inverted"
      @click.native="$emit('onLeftClick')"
      :title="$t('common.previous')"
    />
    <ArrowButton
      direction="right"
      :arrow-disabled="rightArrowDisabled"
      :inverted="inverted"
      @click.native="$emit('onRightClick')"
      :title="$t('common.next')"
    />
  </div>
</template>

<script>
import ArrowButton from '@/components/common/ArrowButton';

export default defineNuxtComponent({
  components: { ArrowButton },
  emits: ['onLeftClick', 'onRightClick'],
  props: {
    leftArrowDisabled: {
      type: Boolean,
      default: false,
    },
    rightArrowDisabled: {
      type: Boolean,
      default: false,
    },
    inverted: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
